import * as uuid    from 'uuid';
import {GuidString} from './types';

export class Guid {
    public static NewGuid(): GuidString {
        return uuid.v4();
    }
}
